import { Link } from "react-router-dom";
import Cookies from "js-cookie";
import "./SideBar.css";

export default function SideBar() {
    const signedIn = Cookies.get('token') ? Cookies.get('token').length > 5 : false;

    const closeSidebar = () => {
        document.body.classList.remove('on-side');
    };

    const handleLinkClick = () => {
        closeSidebar();
    };

    return (
        <>
            <div className="tl-sidebar-overlay" onClick={closeSidebar}></div>
            <aside className="tl-sidebar-panel">
                <div className="tl-sidebar-header">
                    <Link to="/" className="tl-sidebar-logo" onClick={handleLinkClick}>
                        <img src="assets/img/logo/logo2.png" alt="TextLink" />
                        <span>TextLink</span>
                    </Link>
                    <button className="tl-sidebar-close" onClick={closeSidebar} aria-label="Close menu">
                        <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
                            <line x1="18" y1="6" x2="6" y2="18"></line>
                            <line x1="6" y1="6" x2="18" y2="18"></line>
                        </svg>
                    </button>
                </div>

                <nav className="tl-sidebar-nav">
                    <ul className="tl-sidebar-menu">
                        <li>
                            <Link to="/" onClick={handleLinkClick}>Home</Link>
                        </li>
                        <li>
                            <Link to="/how-textlink-works" onClick={handleLinkClick}>How It Works</Link>
                        </li>
                        <li>
                            <Link to="/recommended-setup" onClick={handleLinkClick}>Recommended SIMs &amp; Devices</Link>
                        </li>
                        <li>
                            <Link to="/ghl" onClick={handleLinkClick}>GoHighLevel</Link>
                        </li>
                        <li>
                            <Link to="/pricing" onClick={handleLinkClick}>Pricing</Link>
                        </li>
                        <li>
                            <Link to="/affiliate-program" onClick={handleLinkClick}>Affiliate</Link>
                        </li>
                        <li>
                            <Link to="/contact" onClick={handleLinkClick}>Contact</Link>
                        </li>
                    </ul>

                    <div className="tl-sidebar-divider"></div>

                    <div className="tl-sidebar-actions">
                        {!signedIn && (
                            <Link to="/signin" className="tl-sidebar-btn tl-sidebar-btn-secondary" onClick={handleLinkClick}>
                                Sign in
                            </Link>
                        )}
                        <Link 
                            to={signedIn ? "/dashboard" : "/signup"} 
                            className="tl-sidebar-btn tl-sidebar-btn-primary" 
                            onClick={handleLinkClick}
                        >
                            {signedIn ? "Dashboard" : "Start sending free"}
                            <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
                                <path d="M5 12h14M12 5l7 7-7 7"/>
                            </svg>
                        </Link>
                    </div>
                </nav>
            </aside>
        </>
    );
}
